import React from 'react';
import { Calendar } from 'lucide-react';

interface DateSelectorProps {
  date: string;
  onChange: (date: string) => void;
  disabled?: boolean;
}

export const DateSelector: React.FC<DateSelectorProps> = ({ date, onChange, disabled }) => {
  return (
    <div className="relative max-w-sm">
      <label htmlFor="date-picker" className="block text-sm font-medium text-slate-700 mb-1">
        报告日期
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Calendar className="h-5 w-5 text-slate-400" />
        </div>
        <input
          id="date-picker"
          type="date"
          value={date}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="bg-slate-50 border border-slate-300 text-slate-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        />
      </div>
    </div>
  );
};